import { baseUrl_SPB } from '../../BaseUrl';

const TRADE_JOB_CREATE_ENDPOINTS = [
  '/api/v1/tradejob/addtradejob',
  '/api/v1/tradejob/createtradejob',
  '/api/v1/tradejob/save',
];

export default async function AddTradeJob(formData, token) {
  const tokenv = token ? token.toString() : '';
  let lastError = null;

  for (let i = 0; i < TRADE_JOB_CREATE_ENDPOINTS.length; i += 1) {
    const endpoint = TRADE_JOB_CREATE_ENDPOINTS[i];
    try {
      const response = await fetch(`${baseUrl_SPB}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + tokenv,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        lastError = new Error(`Request failed (${response.status}) for ${endpoint}`);
        continue;
      }

      const jsonResponse = await response.json();
      return jsonResponse;
    } catch (error) {
      lastError = error;
    }
  }

  console.error('Error creating trade job:', lastError);
  return null;
}
